export interface TimeTrackingsDayJson {
  date: string;
  validated: boolean;
  duration: number; // en minutes
}

export class TimeTrackingsDay {
  constructor(
    public date?: string,
    public validated?: boolean,
    public duration?: number
  ) {}

  static fromJson(json: TimeTrackingsDayJson): TimeTrackingsDay {
    return new TimeTrackingsDay(json.date, json.validated ?? false, json.duration ?? 0);
  }
}
